export class GameData {
    getWinningPlayer() {
        for (const playerData of this.players){
            if (playerData.rank == 1) return playerData;
        }
        return undefined;
    }
    static deserialize(data) {
        return Object.assign(new GameData(), data);
    }
    constructor(){
        this.players = [];
        this.userStats = [];
    }
}
